<template style="height: 100%">
  <article class="message menuInter">
    <div class="message-body">
      <div class="has-text-right">
        <button class="delete" aria-label="delete" v-on:click="close"></button>
      </div>
      <!-- First part -->
      <div class="has-text-centered">
        <!-- Title -->
        <div v-if="config.seriesName">
          <div
            class="heading is-size-6 border"
            :class="titleBg"
            style="padding: 5px; margin-top: 15px; text-transform: capitalize;"
          >
            <!-- Text -->
            <div class="is-size-4 has-text-weight-bold">
              {{ config.seriesName }}
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <!-- Info -->
      <div v-if="config.data">
        <!-- Definition -->
        <div v-if="config.dataG['def']">
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">book</i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                Definición
              </p>
              <div class="card-header-icon" v-on:click="switchElement('def')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.def ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <p v-if="elements.def" class="has-text-justified">
              {{ config.dataG["def"] }}
            </p>
          </transition>
        </div>
        <br />
        <!-- Interpretation -->
        <div v-if="config.data['inter']">
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">import_contacts</i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                Interpretación
              </p>
              <div class="card-header-icon" v-on:click="switchElement('inter')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.inter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <p v-if="elements.inter" class="has-text-justified">
              {{ config.data["inter"] }}
            </p>
          </transition>
        </div>
        <br />
        <!-- Meta -->
        <div v-if="config.data['meta']">
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">trending_up</i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                Meta
              </p>
              <div class="card-header-icon" v-on:click="switchElement('meta')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.meta ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <p v-if="elements.meta" class="has-text-justified">
              {{ config.data["meta"] }}
            </p>
          </transition>
        </div>
        <br />
        <!-- Meta -->
        <div v-if="config.dataG['pract']">
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">format_list_numbered</i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                Recomendaciones
              </p>
              <div class="card-header-icon" v-on:click="switchElement('pract')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.pract ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <div v-if="elements.pract">
              <ul style="padding: 0 1.5em">
                <li
                  v-for="(a, k) in deleteEmptyElements(
                    config.dataG['pract'].split('-')
                  )"
                  :key="k"
                >
                  <span v-if="a" style="width: 100%">
                    {{ a }}
                  </span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
        <br />
      </div>
    </div>
  </article>
</template>

<script>
import json from "../interpretaciones.json";
export default {
  data() {
    return {
      config: {},
      interpretations: json,
      elements: {
        def: true,
        inter: true,
        meta: false,
        pract: false,
      },
      titleBg: "rango0",
    };
  },
  props: {
    data: Object,
    type: Number,
  },
  methods: {
    getDataGraph() {
      const data = this.data;
      this.config = {
        group: data.config.series[0].data[data.dataPointIndex].group,
        subgroup: data.config.series[0].data[data.dataPointIndex].key,
        seriesName: data.config.series[0].data[data.dataPointIndex].x,
        dataValue: data.config.series[0].data[data.dataPointIndex].y,
        valueColor: data.config.colors[data.dataPointIndex],
        dataTarget: data.config.series[0].data[data.dataPointIndex].goals
          ? data.config.series[0].data[data.dataPointIndex].goals[0].value
          : 0,
        targetColor: data.config.series[0].data[data.dataPointIndex].goals
          ? data.config.series[0].data[data.dataPointIndex].goals[0].strokeColor
          : 0,
        data: null,
        dataG: null,
      };
      this.config.data = this.interpretations[this.config.group].dimensiones[
        this.config.subgroup
      ].rango[this.ranges(this.config.dataValue)];
      this.config.dataG = this.interpretations[this.config.group].dimensiones[
        this.config.subgroup
      ];
      this.titleBg = `rango${this.ranges(
        this.config.dataValue ? this.config.dataValue : 0
      )}`;
      console.log(this.config);
    },
    getDataDetail() {
      const data = this.data;
      this.config = {
        group: data.group,
        subgroup: data.subGroup,
        seriesName: data.title,
        dataValue: data.p,
        valueColor: data.color,
        dataTarget: 0, // no tenemos target en el momento
        targetColor: 0, // no tenemos target en el momento
        data: null,
        dataG: null,
      };

      this.config.data = this.interpretations[this.config.group].dimensiones[
        this.config.subgroup
      ].rango[this.ranges(this.config.dataValue)];
      this.config.dataG = this.interpretations[this.config.group].dimensiones[
        this.config.subgroup
      ];

      this.titleBg = `rango${this.ranges(
        this.config.dataValue ? this.config.dataValue : 0
      )}`;
    },
    switchElement(ele) {
      this.elements[ele] = !this.elements[ele];
    },
    close() {
      this.$emit("closeMenuInter");
    },
    deleteEmptyElements(array) {
      return array.filter(function(el) {
        return !!el.length;
      });
    },
    ranges(n) {
      let returned;
      if (n === 0) {
        returned = 5;
      } else if (isNaN(n)) {
        returned = 0;
      } else if (n >= 84) {
        // Mayor o igual a 84
        returned = 1;
      } else if (n >= 70 && n <= 83.9) {
        // Mayor o igual a 70 y Menor o igual 83.9
        returned = 2;
      } else if (n >= 30 && n <= 69.9) {
        // Mayor o igual a 30 y Menor o igual 69.9
        returned = 3;
      } else if (n >= 16 && n <= 29.9) {
        // Mayor o igual a 16 y Menor o igual 29.9
        returned = 4;
      } else {
        returned = 5;
      }
      return returned;
    },
  },
  created() {
    if (this.type === 0) this.getDataGraph();
    if (this.type === 1) this.getDataDetail();
  },
  watch: {
    data(nv, ov) {
      if (this.type === 0) this.getDataGraph();
      if (this.type === 1) this.getDataDetail();
    },
  },
};
</script>
<style lang="scss">
.menuInter {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
  height: 100%;
  position: fixed;
  background: white;
  z-index: 251;
  top: 0;
  right: 0;
  overflow: scroll;
  border-radius: 0 0 0 0 !important;
}

.border {
  border-radius: 10px;
}

ul {
  list-style: disc !important;
}
</style>
<style lang="scss">
.rango1 {
  background-color: #76be7c !important;
  color: white !important;
}

.rango2 {
  background-color: #d9ead3 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: #fde8af !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: #f5bc95 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: #fda0a0 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: #a5a5a5;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/menuInterpretacion.vue